// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-input-icon {
  color: var(--color-icon-base);
  text-align: center;
  width: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/common/ui/search-input/SearchInputIcon.less"],"names":[],"mappings":"AACA;EACE,6BAAA;EACA,kBAAA;EACA,WAAA;AAAF","sourcesContent":["\n.search-input-icon {\n  color: var(--color-icon-base);\n  text-align: center;\n  width: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
